import React from "react";
import Swal from "sweetalert2";
import doc3Service from "../../../services/doc3.service";

const BtnDeleteDoc3 = (props: { id: number; type: string }) => {
  const { type, id } = props;

  const onDelete = () => {
    Swal.fire({
      title: `ต้องการลบ ${type}3 | R-1?`,
      text: `คุณต้องการลบ ${type}3 | R-1 รหัส ${id} ใช่หรือไม่!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่, ลบเลย!",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        //ยิงไปหลังบ้าน delete แล้วลบ ค่อยแสดงข้อความ
        doc3Service
          .delele(id)
          .then(() => {
            Swal.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success",
            ).then(() => {
              window.location.reload();
            });
          })
          .catch(() => {
            Swal.fire(
              "มีบางอย่างผิดผลาด!",
              `ตรวจสอบดูว่ามี ${type}5 ของวิชานี้อยู่หรือไม่.`,
              "error",
            );
          });
      }
    });
  };
  return (
    <>
      <button className="btn btn-sm btn-danger" onClick={onDelete}>
        ลบ
      </button>
    </>
  );
};

export default BtnDeleteDoc3;
